/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiUserActionType;
(function (ApiUserActionType) {
    ApiUserActionType["PAGE_VIEW"] = "USER_ACTION_TYPE_PAGE_VIEW";
    ApiUserActionType["LEAD_SCORE"] = "USER_ACTION_TYPE_LEAD_SCORE";
    ApiUserActionType["LEAD_STATUS"] = "USER_ACTION_TYPE_LEAD_STATUS";
    ApiUserActionType["RETENTION"] = "USER_ACTION_TYPE_RETENTION";
})(ApiUserActionType || (ApiUserActionType = {}));
export function ApiUserActionTypeFromJSON(json) {
    return ApiUserActionTypeFromJSONTyped(json, false);
}
export function ApiUserActionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiUserActionTypeToJSON(value) {
    return value;
}
